import { render, staticRenderFns } from "./headerNav-customer-menu.vue?vue&type=template&id=1399b982&"
import script from "./headerNav-customer-menu.vue.ts?vue&type=script&lang=ts&"
export * from "./headerNav-customer-menu.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports